// modules/inicio/offline/listasCache.js
//
// Cache offline de los catálogos (territorios, comunidades, AATI, etnias,
// EPS/EAPB) para que los formularios de captura puedan mostrar sus selects
// sin conexión. Estrategia: "cache completo, filtrar en JS" — se guarda el
// catálogo entero (sin filtrar por territorio) cada vez que hay conexión,
// y el filtro por territorio (para AATI/comunidades) se aplica siempre en
// el navegador, esté online u offline. Así no hace falta ir cacheando
// combinación por combinación de municipio.
//
// Cada función: si hay conexión, intenta traer del servidor y refresca la
// cache; si falla o no hay conexión, lee lo último que quedó guardado en
// IndexedDB (Dexie). Nunca revienta el formulario por falta de red — en el
// peor caso, el select sale vacío con lo último que se alcanzó a cachear.

import db from "../../../offline/db";
import { getTerritorios, getComunidades, getAatis, getEtnias, getEapbs } from "../api/listasAPI";

async function refrescarCache(tabla, fetchFn) {
  const res = await fetchFn();
  await db[tabla].clear();
  await db[tabla].bulkAdd(res.data);
  return res.data;
}

function normalizarTerritorio(t) {
  return (t || "").trim().toLowerCase();
}

export async function obtenerTerritorios() {
  if (navigator.onLine) {
    try {
      return await refrescarCache("listas_territorios_cache", getTerritorios);
    } catch (e) {
      console.error("No se pudo refrescar territorios, usando cache:", e.message);
    }
  }
  return db.listas_territorios_cache.toArray();
}

export async function obtenerComunidades(territorio) {
  let todas;
  if (navigator.onLine) {
    try {
      todas = await refrescarCache("listas_comunidades_cache", () => getComunidades());
    } catch (e) {
      console.error("No se pudo refrescar comunidades, usando cache:", e.message);
      todas = await db.listas_comunidades_cache.toArray();
    }
  } else {
    todas = await db.listas_comunidades_cache.toArray();
  }
  if (!territorio) return todas;
  return todas.filter(c => normalizarTerritorio(c.territorio) === normalizarTerritorio(territorio));
}

export async function obtenerAatis(territorio) {
  let todas;
  if (navigator.onLine) {
    try {
      todas = await refrescarCache("listas_aatis_cache", () => getAatis());
    } catch (e) {
      console.error("No se pudo refrescar AATIs, usando cache:", e.message);
      todas = await db.listas_aatis_cache.toArray();
    }
  } else {
    todas = await db.listas_aatis_cache.toArray();
  }
  if (!territorio) return todas;
  return todas.filter(a => normalizarTerritorio(a.territorio) === normalizarTerritorio(territorio));
}

export async function obtenerEtnias() {
  if (navigator.onLine) {
    try {
      return await refrescarCache("listas_etnias_cache", getEtnias);
    } catch (e) {
      console.error("No se pudo refrescar etnias, usando cache:", e.message);
    }
  }
  return db.listas_etnias_cache.toArray();
}

export async function obtenerEapbs() {
  if (navigator.onLine) {
    try {
      return await refrescarCache("listas_eapbs_cache", getEapbs);
    } catch (e) {
      console.error("No se pudo refrescar EPS/EAPB, usando cache:", e.message);
    }
  }
  return db.listas_eapbs_cache.toArray();
}
